module.exports = __webpack_public_path__ + "media/images/btn_download_manual_horses-5f3b70ff9c3248059ef52f4010fd3ccb.gif";